import { allCountries } from "country-telephone-data";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import Datetime from "react-datetime";
import Autocomplete from "react-google-autocomplete";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import api from "../../../../../api/api";
import {
  calender_image,
  email_image,
  gender_image,
  grade_image,
  language_image,
  location_image,
  profile_image,
  upload_image,
} from "../../../../../assets/images/images";
import EditSubject from "../../../../../components/EditSubject.js/EditSubject";
import { GOOGLE_MAP_KEY } from "../../../../../consts/constants";
import { useAuth } from "../../../../../features/auth/AuthContext";
import { updateGlobalState } from "../../../../../state/global/slice";
import { compressImage } from "../../../../../utils/CompressImage";
import { genders } from "../../../../../utils/consts";
import { getKeyByValue, toTitleCase } from "../../../../../utils/utlis";
import {
  isMaxChar,
  isRequired,
  isValidName,
} from "../../../../../utils/validator";
import CropProfileImageModal from "../../dashboard/CropProfileImageModal";
import "./StudentSideProfile.css";
import dayjs from "dayjs";
import upload_file from "../../../../../assets/images/upload_file.svg"
import csv_img from "../../../../../assets/images/csv-file.png";
import file_img_storage from "../../../../../assets/images/file-storage.png";
import png_svg from "../../../../../assets/images/png-svg.svg";
import jpg_svg from "../../../../../assets/images/jpg-svg.svg";
import doc_svg from "../../../../../assets/images/doc-svg.svg";
import pdf_svg from "../../../../../assets/images/pdf-svg.svg";
import txt_svg from "../../../../../assets/images/txt-svg.svg";
import xls_svg from "../../../../../assets/images/xls-svg.svg";
import svg_svg from "../../../../../assets/images/svg-svg.svg";
// import * as pdfjsLib from 'pdfjs-dist';
import FilePreviewModal from "../../../../../components/UploadDocument/FilePreviewModal";
import { validateFilesForUpload } from "../../../../../components/FileRepo/utils/fileValidation";
// pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

function StudentSideProfile() {
  const { token } = useAuth();
  const globalState = useSelector((state) => state.globalState);
  const dispatch = useDispatch();

  const today = new Date().toISOString().split("T")[0];
  const [isEditable, setIsEditable] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageUploaded, setImageUploaded] = useState(false);
  const [uplodedImage, setUplodedImage] = useState({});
  const [gradedetails, setGradedetails] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isAddToSubjetModelOpen, setIsAddToSubjetModelOpen] = useState(false);
  const [src, setSrc] = useState(null);
  const flattenFiles = (arr) => {
  if (!Array.isArray(arr)) return [];
  return arr.flat(Infinity);
};

const [profileFiles, setProfileFiles] = useState(
  flattenFiles(globalState.student_details?.data?.files)
);

const [removedFileIds, setRemovedFileIds] = useState([]);
  const [pendingFiles, setPendingFiles] = useState([]); 
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewIndex, setPreviewIndex] = useState(0);
  const [previewFiles, setPreviewFiles] = useState([]);
  const [AddtoLanguages, setAddtoLanguages] = useState(
    globalState.datalist?.languages ? globalState.datalist?.languages : []
  );

  const ai_avatar = globalState.student_details?.data?.student_profile_pic;

  const updateState = (key, value) => {
    dispatch(updateGlobalState({ key: key, value: value }));
  };

  const getFormattedDate = (isoDate) => {
    if (!isoDate) return "";
    const dateObj = new Date(isoDate);
    const options = { year: "numeric", month: "short", day: "numeric" };
    return dateObj.toLocaleDateString("en-US", options);
  };

  const [formState, setFormState] = useState({
    name: globalState.student_details?.data?.name,
    grade: Object.keys(globalState.student_details?.data?.grade || {})[0],
    introduction: globalState.student_details?.data?.introduction,
    email: globalState.student_details?.data?.email,
    interest_names: Object.values(globalState.student_details?.data?.interest || {}),
    subject: Object.values(globalState.student_details?.data?.subjects || {}),
    dob: globalState.student_details?.data?.dob,
    gender: Object.keys(globalState.student_details?.data?.gender || {})[0],
    language: Object.values(globalState.student_details?.data?.language || {})?.join(","),
    location: globalState.student_details?.data?.location,
    special_ability: globalState.student_details?.data?.special_ability || "", 
  });

  const [formErrors, setFormErrors] = useState({
    name: "",
    grade: "",
    introduction: "",
    email: "",
    dob: "",
    gender: "",
    location: "",
    language: "",
  });

  // ── Grade last update read-only logic ──  
  const lastGradeUpdate = new Date(globalState?.student_details?.data?.grade_last_update);
  const currentDate = new Date();
  const timeDiff = currentDate.getTime() - lastGradeUpdate.getTime();
  const daysDiff = timeDiff / (1000 * 3600 * 24);
  const isReadOnly = daysDiff < 14;


  

  // ── Fetch grade list ──
  useEffect(() => {
    api.get("/courses/get-grade-list/", {
      headers: { "Content-Type": "multipart/form-data", Authorization: `Token ${token}` },
    })
    .then((response) => {
      if (response.status === 200) setGradedetails(response.data.grade);
    })
    .catch(() => {});
  }, [token]);

  function isValidDateStudent(val) {
    let today = new Date();
    let fourYearsAgo = new Date();
    fourYearsAgo.setFullYear(today.getFullYear() - 4);
    fourYearsAgo.setHours(0, 0, 0, 0);
    let selectedDate = new Date(val);
    selectedDate.setHours(0, 0, 0, 0);
    if (selectedDate > today || selectedDate > fourYearsAgo) return false;
    return true;
  }

const allowedFileExtensions = [
  '.doc', '.docx', '.pdf', '.xls', '.xlsx', '.csv', 
  '.jpg', '.jpeg', '.png', '.svg', '.heic', '.webp'
];

const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024; // 5MB

const countPdfPages = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const text = new Uint8Array(e.target.result);
      const str = new TextDecoder('latin1').decode(text);
      const matches = str.match(/\/Type\s*\/Page[^s]/g);
      resolve(matches ? matches.length : 0);
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
};

const handleProfileFileUpload = async (event) => {
  const file = event.target.files[0];
  if (!file) return;

  // ── 1. Extension validation ──
  const fileExtension = file.name.split('.').pop().toLowerCase();
  if (!allowedFileExtensions.includes(`.${fileExtension}`)) {
    toast.error(`${fileExtension} files cannot be uploaded.`);
    event.target.value = null;
    return;
  }

  // ── 2. Size validation ──
  if (file.size > MAX_FILE_SIZE_BYTES) {
    toast.error("File size exceeds 5MB limit.");
    event.target.value = null;
    return;
  }

  // ── 3. Corruption check ──
  // const isValid = await checkFileCorruption(file);
      const { validFiles, invalidFiles } =
        await validateFilesForUpload([file]);
  if (invalidFiles?.length > 0) {
    toast.error(`Your attached file ${file.name} is corrupted.`);
    event.target.value = null;
    return;
  }

  // ── 4. PDF page count (max 10) ──
 if (file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')) {
  try {
    const pageCount = await countPdfPages(file);
    if (pageCount > 10) {
      toast.error("You can upload up to 10 pages only.");
      event.target.value = null;
      return;
    }
  } catch (err) {
    // Allow if can't read — same as UploadDocument
  }
}

  const newFile = {
    id: Math.random().toString(36).substr(2, 9),
    file: file,
    file_name: file.name,
    file_url: URL.createObjectURL(file),
    isNew: true,
  };

  setPendingFiles((prev) => [...prev, newFile]);
  event.target.value = null;
  toast.success("File added successfully!", { position: "top-center" })
};

// const checkFileCorruption = (file) => {
//   return new Promise(async (resolve) => {
//     try {
//       if (file.type.startsWith('image/')) {
//         const img = new Image();
//         const objectUrl = URL.createObjectURL(file);
//         img.onload = () => { URL.revokeObjectURL(objectUrl); resolve(true); };
//         img.onerror = () => { URL.revokeObjectURL(objectUrl); resolve(false); };
//         img.src = objectUrl;
//         return;
//       }
//       if (file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')) {
//         try {
//           const fileUrl = URL.createObjectURL(file);
//           const loadingTask = pdfjsLib.getDocument(fileUrl);
//           const pdf = await loadingTask.promise;
//           URL.revokeObjectURL(fileUrl);
//           resolve(pdf.numPages > 0);
//         } catch { resolve(false); }
//         return;
//       }
//       const ext = file.name.split('.').pop().toLowerCase();
//       if (['docx', 'xlsx', 'pptx', 'zip'].includes(ext)) {
//         const buffer = await file.slice(0, 4).arrayBuffer();
//         const bytes = new Uint8Array(buffer);
//         resolve(bytes[0] === 0x50 && bytes[1] === 0x4B);
//         return;
//       }
//       const reader = new FileReader();
//       reader.onload = () => resolve(true);
//       reader.onerror = () => resolve(false);
//       reader.readAsArrayBuffer(file);
//     } catch { resolve(false); }
//   });
// };


const [dobInputValue, setDobInputValue] = useState(() => {
  if (!formState.dob) return "";
  const parsed = dayjs(formState.dob);
  return parsed.isValid() ? parsed.format("MM/DD/YYYY") : "";
});

const handleDobInput = (e) => {
  const raw = e.target.value;

  if (raw.length < dobInputValue.length) {
    setDobInputValue(raw);
    if (raw.length < 10) setFormState((prev) => ({ ...prev, dob: "" }));
    return;
  }

  let digits = raw.replace(/\D/g, "");
  let value = digits;
  if (digits.length >= 3 && digits.length <= 4) {
    value = digits.slice(0, 2) + "/" + digits.slice(2);
  } else if (digits.length >= 5) {
    value = digits.slice(0, 2) + "/" + digits.slice(2, 4) + "/" + digits.slice(4, 8);
  }

  setDobInputValue(value);

  if (value.length === 10) {
    const parsed = dayjs(value, "MM/DD/YYYY", true);
    if (!parsed.isValid()) {
      setFormErrors((prev) => ({ ...prev, dob: "Please enter a valid date (MM/DD/YYYY)" }));
      setFormState((prev) => ({ ...prev, dob: "" }));
      return;
    }
    const today = new Date();
    const selectedDate = parsed.toDate();
    const minDate = new Date();
    minDate.setFullYear(today.getFullYear() - 4);

    if (selectedDate > today) {
      setFormErrors((prev) => ({ ...prev, dob: "Date of birth cannot be in the future" }));
      setFormState((prev) => ({ ...prev, dob: "" }));
      return;
    }
    if (selectedDate > minDate) {
      setFormErrors((prev) => ({ ...prev, dob: "Student must be at least 4 years old" }));
      setFormState((prev) => ({ ...prev, dob: "" }));
      return;
    }
    setFormState((prev) => ({ ...prev, dob: parsed.format("YYYY-MM-DD") }));
    setFormErrors((prev) => ({ ...prev, dob: "" }));
  } else {
    setFormState((prev) => ({ ...prev, dob: "" }));
    setFormErrors((prev) => ({ ...prev, dob: "" }));
  }
};

const handleProfileFileRemove = (fileIdentifier, isNew) => {
  if (isNew) {
    setPendingFiles((prev) => prev.filter((f) => f.id !== fileIdentifier));
    toast.success("File removed successfully!", { position: "top-center" });
  } else {
    setProfileFiles((prev) => prev.filter((f) => f.url !== fileIdentifier));
    toast.success("File removed successfully!", { position: "top-center" });
  }
};

  const handleDateChanged = (value) => {
    setFormErrors((prev) => ({ ...prev, dob: isRequired(value) }));
    setFormState((prev) => ({ ...prev, dob: format(new Date(value), "yyyy-MM-dd") }));
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    let error = "";

    if (value.trim() === "") {
      error = "• This field is required";
    } else {
      if (name === "name") error = isRequired(value) || isValidName(value);
      else if (name === "introduction") error = isRequired(value) || isMaxChar(value);
      else if (name === "grade") error = isRequired(value);
      else if (name === "gender") error = value === "" || value === "0" ? "• Please select gender" : "";
      else if (name === "location") error = isRequired(value);
      else if (name === "language") error = isRequired(value);
    }

    if (name === "language" && value.trim() !== "") {
      setFormErrors((prev) => ({ ...prev, language: "" }));
    }

    setFormErrors((prev) => ({ ...prev, [name]: error }));
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  // getUpdatedFields to NOT skip arrays blindly
const getUpdatedFields = () => {
  return Object.entries(formState).reduce((result, [key, value]) => {
    if (value === null) return result;
    const studentValue = globalState.student_details?.data[key];
    if (Array.isArray(value)) {
      // Still skip here — arrays (interest_names) handled separately below
      return result;
    }
    if (value !== studentValue) {
      result[key] = value;
    }
    return result;
  }, {});
};

const submitForm = async () => {
  toast.dismiss();
  const updatedFields = getUpdatedFields();

  if (formState.language) {
  const langNames = formState.language.split(",").filter(Boolean);
  const langIds = langNames
    .map((name) => {
      const key = getKeyByValue(AddtoLanguages, name.trim());
      return key ? parseInt(key) : null;
    })
    .filter(Boolean);
  if (langIds.length > 0) {
    updatedFields.language = langIds;  // array of all language IDs
  }
}

  const originalInterests = Object.values(globalState.student_details?.data?.interest || {});
  const currentInterests = formState.interest_names || [];
  const interestsChanged =
    JSON.stringify([...originalInterests].sort()) !== JSON.stringify([...currentInterests].sort());
  if (interestsChanged) {
    updatedFields.interest_names = currentInterests.join(",");
  }

  const originalSubjects = Object.values(globalState.student_details?.data?.subject || {});
  const currentSubjects = formState.subject || [];
  const subjectsChanged =
    JSON.stringify([...originalSubjects].sort()) !== JSON.stringify([...currentSubjects].sort());
  if (subjectsChanged) {
    updatedFields.subject = currentSubjects.join(",");
  }

  delete updatedFields.email;

  const totalFiles = profileFiles.length + pendingFiles.length;

  //  Has files — send FormData ──
  const formData = new FormData();
 Object.entries(updatedFields).forEach(([key, value]) => {
  if (value !== undefined && value !== null) {
    if (Array.isArray(value)) {
      value.forEach((v) => formData.append(key, v)); // ← append each array item separately
    } else {
      formData.append(key, value);
    }
  }
});

  // ── Fetch existing files ──
  for (const f of profileFiles) {
    if (f.url) {
      try {
        const res = await fetch(f.url);
        const blob = await res.blob();
        const existingFile = new File([blob], f.name, { type: blob.type });
        formData.append("files", existingFile);
      } catch (err) {
        console.error("Failed to fetch existing file:", f.name, err);
      }
    }
  }

  // ── Append new pending files ──
  pendingFiles.forEach((f) => formData.append("files", f.file));

  try {
    const response = await api.put("students/update-student/", formData, {
      headers: { "Content-Type": "multipart/form-data", Authorization: `Token ${token}` },
    });

    if (response?.data?.status === 200) {
      // updateState("student_details", response?.data ?? {});  //replace with updatedStudentDetails to preserve grade_last_update for read-only logic:bug PR1-I1195
      const updatedStudentDetails = {
  ...response?.data,
  data: {
    ...response?.data?.data,
    grade_last_update:
      response?.data?.data?.grade_last_update ??
      globalState?.student_details?.data?.grade_last_update,
  },
};

updateState("student_details", updatedStudentDetails);
      setIsEditable(false);
      setPendingFiles([]);
      const freshFiles = flattenFiles(response?.data?.data?.files);
      setProfileFiles(freshFiles);
      toast.success(
        response?.data?.message || "Student profile has been updated successfully.",
        { position: "top-center" }
      );
    } else {
      setIsEditable(false);
      toast.error(response?.data?.message || "Something went wrong!", {
        position: "top-center",
      });
    }
  } catch (error) {
    setIsEditable(false);

      // Restore the original grade when update fails
  setFormState((prev) => ({
    ...prev,
    grade: Object.keys(
      globalState?.student_details?.data?.grade || {}
    )[0] || "",
  }));

    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      "Something went wrong!";

    toast.error(errorMessage, { position: "top-center" });

    // ── Key fix: if backend rejects due to file type, ──
    // remove the offending pending files from UI ──
    if (error?.response?.status === 400 && errorMessage) {
      // Extract rejected file type from message e.g. "File type '.svg' is not allowed"
      const match = errorMessage.match(/File type '\.(\w+)' is not allowed/i);
      if (match) {
        const rejectedExt = match[1].toLowerCase();
        // Remove from pendingFiles
        setPendingFiles((prev) =>
          prev.filter((f) => !f.file_name?.toLowerCase().endsWith(`.${rejectedExt}`))
        );
        // Remove from profileFiles
        setProfileFiles((prev) =>
          prev.filter((f) => !f.name?.toLowerCase().endsWith(`.${rejectedExt}`))
        );
      }
    }
  }
};
  const handleSaveForm = (event) => {
    event.preventDefault();
    handleForm4Submit();
  };

  const handleForm4Submit = async () => {
    await submitForm();
  };

  // ── Location handlers ──
  const [hasSelectedPlace, setHasSelectedPlace] = useState(
    globalState.student_details?.data?.location ? true : false
  );

  const handlePlaceSelect = (place) => {
    if (place && place.formatted_address) {
      setFormState((prev) => ({ ...prev, location: place.formatted_address }));
      setFormErrors((prev) => ({ ...prev, location: "" }));
      setHasSelectedPlace(true);
    } else {
      setFormErrors((prev) => ({ ...prev, location: "• Please enter a valid location" }));
    }
  };

  const handleAutocompleteInputChange = (event) => {
    const value = event.target.value;
    if (value.trim() === "") {
      setFormErrors((prev) => ({ ...prev, location: "• This field is required" }));
      setHasSelectedPlace(false);
    } else {
      setFormState((prev) => ({ ...prev, location: value }));
      if (!hasSelectedPlace) {
        setFormErrors((prev) => ({ ...prev, location: "• Please enter a valid location" }));
      } else {
        setFormErrors((prev) => ({ ...prev, location: "" }));
      }
    }
  };

  const handleInputBlur = () => {
    if (!hasSelectedPlace && formState.location) {
      setFormState((prev) => ({ ...prev, location: "" }));
      setFormErrors((prev) => ({ ...prev, location: "• Please enter a valid location" }));
    }
  };

  // ── File/image handlers ──
  const handleFileInput = async (event) => {
    const file = event.target.files[0];
    if (!file) { setSrc(null); return; }
    if (file.size > 31457280) {
      toast.error("The file size exceeds the maximum limit of 1 MB");
      setFormErrors((prev) => ({ ...prev, student_profile_pic: "The file size exceeds the maximum limit of 1 MB" }));
      setSrc(null);
      return;
    }
    const compressedImage = await compressImage(file);
    setSrc(URL.createObjectURL(compressedImage));
    setModalIsOpen(true);
    event.target.value = null;
  };

  // ── Derived display values ──
  const currentGradeLabel = gradedetails[formState.grade] || "—";
  const currentGenderLabel = (() => {
    const genderMap = ["Choose Other", "Male", "Female", "Other"];
    const idx = parseInt(formState.gender);
    if (!isNaN(idx)) return genderMap[idx] || formState.gender;
    return formState.gender || "—";
  })();

  const languageTags = formState.language
    ? formState.language.split(",").filter(Boolean)
    : [];

    // ── File icon helpers (same as UploadDocument) ──
const PngIcon  = () => <img src={png_svg}          alt="PNG" style={{ width: 20, height: 20 }} />;
const JpgIcon  = () => <img src={jpg_svg}          alt="JPG" style={{ width: 20, height: 20 }} />;
const FileDocIcon = () => <img src={doc_svg}       alt="DOC" style={{ width: 20, height: 20 }} />;
const FileXlsIcon = () => <img src={xls_svg}       alt="XLS" style={{ width: 20, height: 20 }} />;
const FileCsvIcon = () => <img src={csv_img}       alt="CSV" style={{ width: 20, height: 20 }} />;
const FilePdfIcon = () => <img src={pdf_svg}       alt="PDF" style={{ width: 20, height: 20 }} />;
const TxtIcon     = () => <img src={txt_svg}       alt="TXT" style={{ width: 20, height: 20 }} />;
const FileSvgIcon = () => <img src={svg_svg}       alt="SVG" style={{ width: 20, height: 20 }} />;
const FileStorageIcon = () => <img src={file_img_storage} alt="File" style={{ width: 20, height: 20 }} />;

const getFileTypeFromName = (filename) => {
  if (!filename || typeof filename !== "string") return "";
  const ext = filename.split(".").pop().toLowerCase();
  const typeMap = {
    png: "image/png", jpg: "image/jpeg", jpeg: "image/jpeg",
    gif: "image/gif", svg: "image/svg+xml", pdf: "application/pdf",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    txt: "text/plain", xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    csv: "text/csv",
  };
  return typeMap[ext] || "";
};

const getFileIcon = (fileType, fileName) => {
  const type = fileType || getFileTypeFromName(fileName);
  if (!type || typeof type !== "string") return <FileStorageIcon />;
  if (type.includes("png"))                                        return <PngIcon />;
  if (type === "text/plain")                                       return <TxtIcon />;
  if (type.includes("jpg") || type.includes("jpeg"))              return <JpgIcon />;
  if (type.includes("pdf"))                                        return <FilePdfIcon />;
  if (type.includes("xls") || type.includes("spreadsheet"))       return <FileXlsIcon />;
  if (type.includes("csv"))                                        return <FileCsvIcon />;
  if (type.includes("svg"))                                        return <FileSvgIcon />;
  if (type.includes("word") || type.includes("document"))         return <FileDocIcon />;
  return <FileStorageIcon />;
};

const allowSubjects = globalState?.enabled_modules?.includes('allow_add_subjects');

const modalTitle = isAddToSubjetModelOpen === "Subject" ? "Subjects" : "Interests";

const submit = (subjects) => {
   if(isAddToSubjetModelOpen === "Subject"){ 
     setFormState((prev) => ({ ...prev, subject : subjects }));
   } else{
     setFormState((prev) => ({ ...prev, interest_names: subjects }));
   }
   setIsAddToSubjetModelOpen(false);
}

const modalSubjectList = isAddToSubjetModelOpen === "Interest" ? Object.values(
            formState?.interest_names || {},
          ) : Object.values(
            formState?.subject || {},
          )
  return (
    <div className="account_setting_tab_sec student">
      {/* ── Header ── */}
      <div className="account_setting_tab_sec_head">
        <h6>Profile Settings</h6>
        {isEditable ? (
          <button
            className="save_btn_set"
            onClick={handleSaveForm}
            disabled={
              !!formErrors.introduction ||
              !!formErrors.name ||
              !!formErrors.location
            }
          >
            Save
          </button>
        ) : (
          <button className="edit_btn_set" onClick={() => setIsEditable(true)}>
            <i className="fa-solid fa-pen"></i> Edit
          </button>
        )}
      </div>

      {/* ── Top: Avatar + About Student ── */}
      <div className="student-profile-top">
        <div className="student-profile-avatar-block">
          <div className="Personalize-your-AI-Assistant-uplode-image">
            <img
              src={selectedImage ?? ai_avatar ?? upload_image}
              alt="profile"
            />
            {isEditable && (
              <div className="profile_plus_icon" style={{ cursor: "pointer" }}>
                <span>
                  <i className="fa-solid fa-plus"></i>
                </span>
              </div>
            )}
            {/* ── Special ability indicator ── */}
            {globalState.student_details?.data?.is_special_ability && (
              <div className="student-side-sp-ability-dot" />
            )}
            <input
              type="file"
              id="choos-profile-image"
              name="student_profile_pic"
              accept="image/png, image/jpeg"
              style={{ height: 106, width: 106 }}
              onChange={handleFileInput}
              disabled={!isEditable}
            />
          </div>
          <h5 style={{ textAlign: "center" }}>{formState.name}</h5>
        </div>

        <div className="student-profile-about-block">
          <h4>About Student</h4>
          {isEditable ? (
            <textarea
              name="introduction"
              style={
                formErrors.introduction ? { border: "1px solid red" } : null
              }
              value={formState.introduction || ""}
              onChange={handleInputChange}
              className="introduce-yourself-text"
              maxLength="1000"
              rows="5"
              placeholder="Tell us about yourself..."
            />
          ) : (
            <p>{formState.introduction || "—"}</p>
          )}
          <p className="errorState">{formErrors.introduction}</p>
        </div>
      </div>

      {/* ── 2-Column Fields Grid ── */}
      <div className="student-profile-fields-grid">
        {/* Name */}
        <div className="student-profile-field">
          <label>Name</label>
          {isEditable ? (
            <input
              type="text"
              name="name"
              style={formErrors.name ? { border: "1px solid red" } : null}
              value={formState.name || ""}
              placeholder="Full name"
              onChange={handleInputChange}
            />
          ) : (
            <p>{formState.name || "—"}</p>
          )}
          <span className="errorState">{formErrors.name}</span>
        </div>

        {/* Email — always read-only */}
        <div className="student-profile-field">
          <label>Email</label>
          <p>{formState.email || "—"}</p>
        </div>

        {/* Grade */}
        <div
          className="student-profile-field"
          // onClick={() => {
          //   if (isReadOnly) {
          //     toast.info("Grade can only be updated once every 14 days.");
          //   }
          // }}
        >
          <label>Grade</label>
          {isEditable ? (
            <select
              name="grade"
    style={{
      ...(formErrors.grade
        ? { border: "1px solid red" }
        : { border: "1px solid #BDBDBD" }),
      borderRadius: 6,
      // pointerEvents: isReadOnly ? "none" : "auto",
      // backgroundColor: isReadOnly ? "#f5f5f5" : "",
      // cursor: isReadOnly ? "not-allowed" : "pointer",
    }}      
    className="grade-select"        
    value={formState.grade || ""}
              
              onChange={handleInputChange}
           //   disabled={isReadOnly}
            >
              <option value="">Select Grade</option>
              {Object.keys(gradedetails).map((key) => (
                <option key={`gradedetails${key}`} value={key}>
                  {gradedetails[key]}
                </option>
              ))}
            </select>
          ) : (
            <p>{currentGradeLabel}</p>
          )}
          <span className="errorState">{formErrors.grade}</span>
        </div>

        {/* Date of Birth */}
        <div className="student-profile-field">
          <label>Date of Birth</label>
          {isEditable ? (
            <Datetime
              name="dob"
              className={formErrors.dob ? "datetime-error" : "datetime"}
              timeFormat={false}
              inputProps={{
                placeholder: "MM/DD/YYYY",
                value: dobInputValue,
                onChange: handleDobInput,
                onBlur: () => {
                  if (dobInputValue.length > 0 && dobInputValue.length < 10) {
                    setFormErrors((prev) => ({ ...prev, dob: "Please enter complete date (MM/DD/YYYY)" }));
                  }
                },
                maxLength: 10,
                style: formErrors.dob ? { border: "1px solid red" } : null,
              }}
              value={dobInputValue}
              closeOnSelect={true}
              onChange={(date) => {
                if (typeof date === "object" && date?.isValid && date.isValid()) {
                  const selectedDate = date.toDate();
                  const today = new Date();
                  const minDate = new Date();
                  minDate.setFullYear(today.getFullYear() - 4);
                  if (selectedDate > today) {
                    setFormErrors((prev) => ({ ...prev, dob: "Date of birth cannot be in the future" }));
                    return;
                  }
                  if (selectedDate > minDate) {
                    setFormErrors((prev) => ({ ...prev, dob: "Student must be at least 4 years old" }));
                    return;
                  }
                  setDobInputValue(date.format("MM/DD/YYYY"));
                  setFormState((prev) => ({ ...prev, dob: date.format("YYYY-MM-DD") }));
                  setFormErrors((prev) => ({ ...prev, dob: "" }));
                }
              }}
              dateFormat="MM/DD/YYYY"
              isValidDate={isValidDateStudent}
            />
          ) : (
            <p>{formState.dob ? getFormattedDate(formState.dob) : "—"}</p>
          )}
          <span className="errorState">{formErrors.dob}</span>
        </div>

        {/* Gender */}
        <div className="student-profile-field">
          <label>Gender</label>
          {isEditable ? (
            <select
            className="gender-select"
              name="gender"
              style={formErrors.gender ? { border: "1px solid red" } : null}
              value={
                Number.isInteger(parseInt(formState.gender))
                  ? formState.gender
                  : getKeyByValue(
                      ["Choose Other", "Male", "Female", "Other"],
                      formState.gender,
                    ) || ""
              }
              onChange={handleInputChange}
            >
              {genders.map((gender) => (
                <option key={gender.value} value={gender.value}>
                  {gender.name}
                </option>
              ))}
            </select>
          ) : (
            <p>{currentGenderLabel}</p>
          )}
          <span className="errorState">{formErrors.gender}</span>
        </div>

        {/* Location */}
        <div className="student-profile-field">
          <label>Location</label>
          {isEditable ? (
            <Autocomplete
              apiKey={GOOGLE_MAP_KEY}
              onPlaceSelected={handlePlaceSelect}
              defaultValue={formState.location}
              onChange={handleAutocompleteInputChange}
              onBlur={handleInputBlur}
              options={{ types: ["(cities)"] }}
            />
          ) : (
            <p>{formState.location || "—"}</p>
          )}
          <span className="errorState">{formErrors.location}</span>
        </div>
      </div>

      {/* ── Diverse Learning Requirement ── */}
      <div className="student-profile-section">
        <div className="student-profile-section-header">
          <h4>Diverse Learning Requirement (If Any)</h4>
        </div>
        {isEditable ? (
          <div className="textarea-upload-wrapper">
            <textarea
              name="special_ability"
              value={formState.special_ability || ""}
              onChange={handleInputChange}
              className="student-diverse-textarea"
              rows="5"
              placeholder="Describe any diverse learning requirements..."
            />
            <label className="textarea-upload-btn">
              <img src={upload_file} alt="upload_file" />
              Upload Document
              <input
                type="file"
                style={{ display: "none" }}
                accept=".doc,.docx,.pdf,.xls,.xlsx,.csv,.jpg,.jpeg,.png,.svg,.heic,.webp"
                onChange={handleProfileFileUpload}
              />
            </label>
          </div>
        ) : (
          <p
            className="student-diverse-text flex-wrap"
            style={{ whiteSpace: "pre-line" }}
          >
            {formState.special_ability || "—"}
          </p>
        )}
        <div className="student-profile-section-header attachment">
          <h4>Attachments</h4>
        </div>

        {(profileFiles.length > 0 || pendingFiles.length > 0) && (
          <>
            <div className="ssp-files-container">
              {/* Already saved files */}
              {profileFiles.map((file, index) => (
                <div
                  key={`saved-${index}`}
                  className="ssp-file-item"
                  title={file.name}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    const allFiles = [
                      ...profileFiles.map((f) => ({
                        name: f.name,
                        url: f.url,
                      })),
                      ...pendingFiles.map((f) => ({
                        name: f.file_name,
                        url: f.file_url,
                      })),
                    ];
                    setPreviewFiles(allFiles);
                    setPreviewIndex(index);
                    setPreviewOpen(true);
                  }}
                >
                  <div className="ssp-file-icon">
                    {getFileIcon("", file.name)}
                  </div>
                  <div className="ssp-file-info">
                    <span className="ssp-file-name">{file.name}</span>
                    {file.uploaded_at && (
                      <span className="ssp-file-size">
                        {new Date(file.uploaded_at).toLocaleDateString(
                          "en-GB",
                          {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          },
                        )}
                      </span>
                    )}
                  </div>
                  {isEditable && (
                    <button
                      className="ssp-file-remove-btn"
                      onClick={(e) => {e.stopPropagation(); handleProfileFileRemove(file.url, false)}}
                      aria-label="Remove file"
                    >
                      <svg
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        style={{ width: "100%", height: "100%" }}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  )}
                </div>
              ))}

              {/* Pending files */}
              {pendingFiles.map((file, index) => (
                <div
                  key={file.id}
                  className="ssp-file-item ssp-file-item--pending"
                  title={file.file_name}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    const allFiles = [
                      ...profileFiles.map((f) => ({
                        name: f.name,
                        url: f.url,
                      })),
                      ...pendingFiles.map((f) => ({
                        name: f.file_name,
                        url: f.file_url,
                      })),
                    ];
                    setPreviewFiles(allFiles);
                    setPreviewIndex(profileFiles.length + index); // offset by saved files count
                    setPreviewOpen(true);
                  }}
                >
                  <div className="ssp-file-icon">
                    {getFileIcon(file.file?.type || "", file.file_name)}
                  </div>
                  <div className="ssp-file-info">
                    <span className="ssp-file-name">{file.file_name}</span>
                  </div>
                  {isEditable && (
                    <button
                      className="ssp-file-remove-btn"
                      onClick={(e) => {e.stopPropagation(); handleProfileFileRemove(file.id, true)}}
                      aria-label="Remove file"
                    >
                      <svg
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        style={{ width: "100%", height: "100%" }}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  )}
                </div>
              ))}
            </div>
          </>
        )}

        {profileFiles.length === 0 && pendingFiles.length === 0 && (
          <span className="student-profile-empty">No documents uploaded</span>
        )}
      </div>

      {/* ── Language ── */}
      <div className="student-profile-section">
        <div className="student-profile-section-header">
          <h4>Language</h4>
          {isEditable && (
            <div className="student-profile-language-select-wrapper">
              <select
                name="language"
                className="student-profile-add-btn"
                defaultValue=""
                onChange={(e) => {
                  if (!e.target.value) return;

                  const selectedLang =
                    AddtoLanguages[e.target.value] || e.target.value;

                  // avoid duplicates
                  if (!languageTags.includes(selectedLang)) {
                    const updated =
                      languageTags.length > 0
                        ? languageTags.join(",") + "," + selectedLang
                        : selectedLang;

                    setFormState((prev) => ({
                      ...prev,
                      language: updated,
                    }));

                    setFormErrors((prev) => ({
                      ...prev,
                      language: "",
                    }));
                  }
                  e.target.value = "";
                }}
              >
                <option value="" disabled hidden>
                  + Add Language
                </option>

                {(() => {
                  const availableLanguages = Object.keys(AddtoLanguages)
                    .filter(
                      (key) =>
                        !!AddtoLanguages[key] &&
                        !languageTags.includes(AddtoLanguages[key]),
                    );
                  
                  if (availableLanguages.length === 0) {
                    return <option disabled>No language found</option>;
                  }
                  
                  return availableLanguages.map((key) => (
                    <option key={key} value={key}>
                      {AddtoLanguages[key]}
                    </option>
                  ));
                })()}
              </select>
            </div>
          )}
        </div>

        <div className="student-profile-tags">
          {languageTags.length > 0 ? (
            languageTags.map((lang, i) => (
              <span key={i} className="student-profile-tag">
                {lang}
                {isEditable && (
                  <i
                    className="fa-solid fa-xmark"
                    style={{
                      cursor: "pointer",
                      marginLeft: 8,
                      fontSize: 11,
                      color: "#9ca3af",
                    }}
                    onClick={() => {
                      const updated = languageTags
                        .filter((l) => l !== lang)
                        .join(",");
                      setFormState((prev) => ({ ...prev, language: updated }));
                    }}
                  />
                )}
              </span>
            ))
          ) : (
            <span className="student-profile-empty">No language added</span>
          )}
        </div>
        <span className="errorState">{formErrors.language}</span>
      </div>

      {/* ── Subjects ── */}
      {allowSubjects && (
      <div className="student-profile-section">
        <div className="student-profile-section-header">
          <h4>Subjects</h4>
          {isEditable && (
            <button
              className="student-profile-add-btn"
              onClick={() => setIsAddToSubjetModelOpen("Subject")}
            >
              + Add Subject
            </button>
          )}
        </div>
        <div className="student-profile-tags">
          {formState.subject?.length > 0 ? (
            formState.subject.map((subject, i) => (
              <span key={i} className="student-profile-tag">
                {toTitleCase(subject)}
              </span>
            ))
          ) : (
            <span className="student-profile-empty">No subjects added</span>
          )}
        </div>
      </div>)}

      {/*    Interests   */}
      <div className="student-profile-section">
        <div className="student-profile-section-header">
          <h4>Interest</h4>
          {isEditable && (
            <button
              className="student-profile-add-btn"
              onClick={() => setIsAddToSubjetModelOpen("Interest")}
            >
              + Add Interest
            </button>
          )}
        </div>
        <div className="student-profile-tags">
          {formState.interest_names?.length > 0 ? (
            formState.interest_names.map((interest, i) => (
              <span key={i} className="student-profile-tag">
                {toTitleCase(interest)}
              </span>
            ))
          ) : (
            <span className="student-profile-empty">No interests added</span>
          )}
        </div>
      </div>

      {/* ── Modals ── */}
      {modalIsOpen && (
        <CropProfileImageModal
          src={src}
          setSrc={setSrc}
          setSelectedImage={setSelectedImage}
          setImageUploaded={setImageUploaded}
          setUplodedImage={setUplodedImage}
          modalStatus={modalIsOpen}
          setModalClose={() => setModalIsOpen(false)}
          fieldName="student_profile_pic"
          setFormState={setFormState}
          formState={formState}
        />
      )}

      {isAddToSubjetModelOpen && (
        <EditSubject
          subject_title={modalTitle}
          modalStatus={isAddToSubjetModelOpen}
          subjectlist={modalSubjectList}
          setModalClose={() => setIsAddToSubjetModelOpen(false)}
          onClose={() => setIsAddToSubjetModelOpen(false)}
          onSubmit={submit}
        />
      )}

      <FilePreviewModal
        isOpen={previewOpen}
        files={previewFiles}
        initialIndex={previewIndex}
        onClose={() => setPreviewOpen(false)}
        getFileIcon={(type, name) => getFileIcon(type, name)}
      />
    </div>
  );
}

export default StudentSideProfile;